var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 11.0833C3.65275 11.0833 0.25 14.485 0.25 18.6667C0.25 19.2647 0.73425 19.75 1.33333 19.75C1.93242 19.75 2.41667 19.2647 2.41667 18.6667C2.41667 15.6799 4.84658 13.25 7.83333 13.25C10.8201 13.25 13.25 15.6799 13.25 18.6667C13.25 19.2647 13.7342 19.75 14.3333 19.75C14.9324 19.75 15.4167 19.2647 15.4167 18.6667C15.4167 14.485 12.0139 11.0833 7.83333 11.0833ZM5.66667 4.58333C5.66667 5.77825 6.63842 6.75 7.83333 6.75C9.02825 6.75 10 5.77825 10 4.58333C10 3.38842 9.02825 2.41667 7.83333 2.41667C6.63842 2.41667 5.66667 3.38842 5.66667 4.58333ZM3.5 4.58333C3.5 2.1935 5.4435 0.25 7.83333 0.25C10.2232 0.25 12.1667 2.1935 12.1667 4.58333C12.1667 6.97317 10.2232 8.91667 7.83333 8.91667C5.4435 8.91667 3.5 6.97317 3.5 4.58333ZM20.5679 3.12733L17.7404 6.37733C17.5357 6.61242 17.241 6.74783 16.929 6.75H16.9225C16.6138 6.75 16.3202 6.61892 16.1154 6.38925L14.6096 4.70683C14.2109 4.2605 14.2488 3.57583 14.6941 3.17717C15.1415 2.77742 15.8262 2.81533 16.2238 3.26167L16.9106 4.02975L18.9321 1.706C19.3253 1.25317 20.0089 1.20658 20.4607 1.59983C20.9124 1.992 20.9601 2.67667 20.5679 3.12733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fcf996056e061da9c79a27fcaeaa2eed.svg";
export { ForwardRef as ReactComponent };